import { render } from "./PartnerDashboard.vue?vue&type=template&id=aaa08202"
import script from "./PartnerDashboard.vue?vue&type=script&lang=js"
export * from "./PartnerDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447385/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__